import { render, staticRenderFns } from "./AdministrativeDashboard.vue?vue&type=template&id=20e68034&scoped=true&"
import script from "./AdministrativeDashboard.vue?vue&type=script&lang=js&"
export * from "./AdministrativeDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AdministrativeDashboard.vue?vue&type=style&index=0&id=20e68034&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e68034",
  null
  
)

export default component.exports